import { render, staticRenderFns } from "./NObjectCardComments.vue?vue&type=template&id=5f9451b6&scoped=true&"
import script from "./NObjectCardComments.vue?vue&type=script&lang=js&"
export * from "./NObjectCardComments.vue?vue&type=script&lang=js&"
import style0 from "./NObjectCardComments.vue?vue&type=style&index=0&id=5f9451b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9451b6",
  null
  
)

export default component.exports